import { FC } from "react";
import { Outlet } from "react-router";

export const AtlasRootOutlet: FC = () => {
  return <Outlet />;
};
